import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import { Row, Col } from "react-bootstrap";

const translations = {
    en: require("../../../Translate/en.json").Branding.Services,
    ar: require("../../../Translate/ar.json").Branding.Services,
};

const ServicesGrid = () => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const tData = translations[isLang || "en"];

    const t = (keyPath) => {
        return keyPath.split('.').reduce((obj, key) => obj?.[key], tData) || "";
    };

    return (
        <div className="services-grid-container">
            <Row  >
                {[
                    "BrandPositioning",
                    "LogoDesign",
                    "Slogan",
                    "StationaryDesign",
                    "PackagingDesign",
                    "SignageDesign",
                ].map((key, index) => (
                    <Col xs={12} sm={6} lg={4} key={`primary-${index}`} className="p-3" >
                        <div className={`service-card ${isLang == "en" ? "ltr" : "rtl"}`}>
                            <h3>{t(`${key}.title`)}</h3>
                            <p>{t(`${key}.description`)}</p>
                        </div>
                    </Col>
                ))}

                {[
                    "IdentityGuideline",
                    "InternalBranding",
                    "CorporateProfile",
                    "BrochureDesign",
                ].map((key, index) => (
                    <Col xs={12} sm={12} lg={6} key={`extra-${index}`} className="p-3">
                        <div className={`service-card  ${isLang == "en" ? "ltr" : "rtl"}`}>

                            <h3>{t(`${key}.title`)}</h3>
                            <p>{t(`${key}.description`)}</p>
                            {key === "IdentityGuideline" && (
                                <div className="mt-2">
                                    <p>✔ {t("IdentityGuideline.benefit1")}</p>
                                    <p>✔ {t("IdentityGuideline.benefit2")}</p>
                                    <p>✔ {t("IdentityGuideline.benefit3")}</p>
                                </div>
                            )}
                        </div>
                    </Col>
                ))}

                {["WhyWait", "WhyWait2"].map((key, index) => (
                    <Col xs={12} sm={12} lg={6} key={`cta-${index}`} className="p-3">
                        <div className={`service-card  ${isLang == "en" ? "ltr" : "rtl"}`}>

                            <h3>{t(`${key}.title`)}</h3>
                            <p>{t(`${key}.description`)}</p>
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default ServicesGrid;
